var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 18,
    viewBox: "0 0 54 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0608 9.00781L53.9728 17.9988H48.7978C48.7978 17.9988 44.6219 12.4818 44.5049 12.3288L47.0608 9.00781Z",
    fill: "url(#paint0_linear_109_1747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.783 14.0208C45.666 13.8588 44.091 11.8427 43.515 10.9967C43.173 10.5017 42.813 9.79977 42.813 8.99878C42.813 8.19778 43.173 7.50475 43.515 7.00075C44.091 6.15476 44.379 5.83078 44.496 5.67778C44.613 5.52479 48.789 0.0078125 48.789 0.0078125H53.964L47.052 8.99878L46.575 9.66477C45.846 10.6818 45.522 11.9598 45.675 13.2288L45.783 14.0208Z",
    fill: "url(#paint1_linear_109_1747)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5351 9.00757L34.623 0.0166016H39.798C39.798 0.0166016 43.974 5.53357 44.091 5.68657L41.5351 9.00757Z",
    fill: "url(#paint2_linear_109_1747)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_109_1747",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 3,
    width: 17,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0466 4.30271C43.1276 4.41071 44.2975 5.94972 44.2975 5.94972L46.0525 3.63672L49.9585 5.23874L47.0605 9.00973L50.9665 14.0857L48.0506 17.0107L44.2975 12.0697C44.2975 12.0697 44.1895 12.1957 44.0905 12.3307C43.9735 12.4927 39.7975 18.0007 39.7975 18.0007H34.6226L41.5346 9.00973L42.0565 8.28074C42.7405 7.30874 43.1906 5.5177 43.0466 4.30271Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_109_1747)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.3022,
    y: 1.74609,
    width: 19.9583,
    height: 22.8095,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0463 4.30225C43.1633 4.46425 44.4862 6.17426 45.0622 7.02026C45.4042 7.51525 45.7642 8.21728 45.7642 9.01828C45.7642 9.81928 45.4042 10.5122 45.0622 11.0162C44.4862 11.8622 44.1982 12.1862 44.0812 12.3392C43.9642 12.5012 39.7883 18.0092 39.7883 18.0092H34.6133L41.5253 9.01828L42.0472 8.28923C42.7402 7.30823 43.1903 5.51724 43.0463 4.30225Z",
    fill: "url(#paint3_linear_109_1747)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0273438 0.0620298V17.99H4.07733V-0.000976562L0.0273438 0.0620298Z",
    fill: "url(#paint4_linear_109_1747)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00232 -0.000976562H0.0273438V0.0620298C2.35834 0.0620298 4.01433 1.25004 4.01433 3.84203C4.01433 3.90503 4.00532 3.67999 4.00532 3.74299H6.75931C9.6483 3.74299 11.7993 5.20101 11.7993 8.999C11.7993 12.797 9.6483 14.2549 6.87631 14.2549H4.00532C4.00532 14.3179 4.01433 14.093 4.01433 14.147C4.01433 17.1979 1.79134 17.927 0.0273438 17.927V17.999H7.05632C12.5373 17.999 15.9933 14.624 15.9933 8.999C15.9933 3.37401 12.5373 -0.000976562 7.00232 -0.000976562Z",
    fill: "url(#paint5_linear_109_1747)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7322 0.0625H15.7773V4.10348H33.1652L33.7322 0.0625Z",
    fill: "#DDDDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7322 0.0625H15.7773V4.10348H33.7322V0.0625Z",
    fill: "url(#paint6_linear_109_1747)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4325 0.0263672C24.8675 0.0263672 22.7886 1.53838 22.7886 4.09437V17.9633H26.2896V5.76835C26.2896 4.40036 27.4056 4.13937 28.0176 4.09437H33.8405V0.0263672H27.4325Z",
    fill: "url(#paint7_linear_109_1747)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_109_1747",
    transform: "scale(0.0136986 0.0121951)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_1747",
    x1: 52.3582,
    y1: 17.9086,
    x2: 45.6091,
    y2: 11.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2169,
    stopColor: "#3FACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4857,
    stopColor: "#4288DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00368D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_1747",
    x1: 47.1171,
    y1: 13.0704,
    x2: 49.2477,
    y2: -1.40959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2545,
    stopColor: "#3FACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6212,
    stopColor: "#4288DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#4085DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3B7CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8871,
    stopColor: "#326DC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9473,
    stopColor: "#2658AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#173F96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_109_1747",
    x1: 36.2341,
    y1: 0.103721,
    x2: 42.9835,
    y2: 6.81267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3258,
    stopColor: "#4288DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3508,
    stopColor: "#3F84DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6393,
    stopColor: "#1D5AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8654,
    stopColor: "#084097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00368D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_109_1747",
    x1: 40.0379,
    y1: 5.88544,
    x2: 40.3297,
    y2: 20.2699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3481,
    stopColor: "#4288DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    stopColor: "#193C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_109_1747",
    x1: 0.672192,
    y1: 8.99836,
    x2: 3.56811,
    y2: 8.99836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0995,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_109_1747",
    x1: 0.0310337,
    y1: 8.99837,
    x2: 15.993,
    y2: 8.99837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6087,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_109_1747",
    x1: 33.7313,
    y1: 2.08047,
    x2: 15.7733,
    y2: 2.08047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6087,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_109_1747",
    x1: 33.8395,
    y1: 8.99871,
    x2: 23.8194,
    y2: 8.99871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6087,
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_109_1747",
    width: 73,
    height: 82,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.865e8c1c5d5e8b31eb512da9c5fa6ee6.svg";
export { ForwardRef as ReactComponent };